import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]
  static values = { minLength: { type: Number, default: 3 }, debounce: { type: Number, default: 300 } }

  search(event) {
    const query = this.inputTarget.value.trim()

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (event?.target.matches("select") || query.length === 0 || query.length >= this.minLengthValue) {
      this.timeout = setTimeout(() => {
        this.formTarget.requestSubmit()
      }, this.debounceValue)
    }
  }
}
